var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCumaru(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1648_3498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2797 16.9318C9.54426 17.9215 8.0281 17.558 7.75765 16.4302C10.257 13.1589 11.7811 9.21568 12.1073 5.06016L12.2722 2.96014C12.2921 2.70701 12.2805 2.46303 12.2415 2.23061C12.699 1.75435 13.1874 1.30272 13.7051 0.878851C14.5616 0.177578 15.84 0.851976 15.7447 1.95488L15.4881 4.92609C15.1689 8.62176 13.8283 12.1559 11.6159 15.1334L10.2797 16.9318Z",
    fill: "#653024"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 17.349V18.5659C0 19.8747 1.55912 20.5558 2.51934 19.6663L4.26453 18.0497C7.9523 14.6337 10.2185 9.95417 10.6119 4.94276L10.7768 2.84274C10.8682 1.67826 9.58592 0.9134 8.60474 1.54717C3.24015 5.01234 0 10.9626 0 17.349ZM6.5761 7.48016C6.84127 7.16195 6.79828 6.68903 6.48007 6.42385C6.16186 6.15868 5.68894 6.20167 5.42377 6.51988C3.70606 8.58112 2.47595 11.0036 1.8252 13.6066L1.77233 13.8181C1.67186 14.22 1.91619 14.6272 2.31803 14.7276C2.71988 14.8281 3.12708 14.5838 3.22754 14.1819L3.28041 13.9704C3.87639 11.5865 5.00297 9.36791 6.5761 7.48016Z",
    fill: "#653024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7232 17.5039L11.7566 17.9258C11.8505 19.1119 13.3045 19.6269 14.124 18.7642L14.5 18.3684C18.0311 14.6514 20 9.72033 20 4.59344V3.70305C20 2.62269 18.7444 2.02795 17.9085 2.71234C17.6399 2.93226 17.379 3.15949 17.1261 3.39359L16.9826 5.05506C16.6395 9.02791 15.1982 12.8271 12.82 16.0279L11.7232 17.5039Z",
    fill: "#653024"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1648_3498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCumaru);
export default __webpack_public_path__ + "static/media/cumaru.be4cb03393f209ddee7059f0116eabac.svg";
export { ForwardRef as ReactComponent };